export const PAGE_SIZE = 20;

/** Common HTTP status codes for the status filter. */
export const STATUS_CODE_OPTIONS = [
  '200',
  '201',
  '400',
  '401',
  '403',
  '404',
  '422',
  '429',
  '500',
  '502',
  '503',
];
